import React from "react";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import "../../../StyleSheet/Page/PlantProject/CreatePlantProject.scss";
import { useDispatch, useSelector } from "react-redux";
import { CreatePlantActions, UpdatePlantActions } from "../../../Redux/Slice";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";

function PlantPopup(props) {
  const {
    show,
    setShow,
    editPayload,
    refresh,
    selectedPlantId,
    setEditPayload,
  } = props;
  const [projectName, setProjectName] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [plantCommonFolder, setplantCommonFolder] = useState([
    "PF_CHALLAN",
    "ESI_CHALLAN",
  ]);
  const dispatch = useDispatch();
  const [checkedItems, setCheckedItems] = useState([]);
  const [uncheckedItems, setUncheckedItems] = useState([]);
  const [Mails, setMails] = useState([]);
  //console.log(checkedItems, uncheckedItems, "true");
  useEffect(() => {
    if (show) {
      setCheckedItems(["PF_CHALLAN", "ESI_CHALLAN"]);
    } else {
      // setCheckedItems([])
      setUncheckedItems([]);
    }
  }, [show]);

  const handleCheckboxChange = (event) => {
    const target = event.target;
    const itemName = target.name;
    const isChecked = target.checked;

    if (isChecked) {
      //console.log("true");
      if (!checkedItems.includes(itemName)) {
        setCheckedItems([...checkedItems, itemName]);
      }
      setUncheckedItems(uncheckedItems.filter((item) => item !== itemName));
    } else {
      //console.log("false");
      setCheckedItems(checkedItems.filter((item) => item !== itemName));
      if (!uncheckedItems.includes(itemName)) {
        setUncheckedItems([...uncheckedItems, itemName]);
      }
    }
  };
  const handleSubmit = () => {
    if (Object.keys(editPayload)?.length > 0) {
      const payload = {
        projectName: {
          plant: projectName,
          plant_common: checkedItems,
          delete_name_list: uncheckedItems,
          emails: Mails,
        },
        id: selectedPlantId,
      };
      dispatch(UpdatePlantActions(payload));
      setTimeout(() => {
        refresh();
      }, 200);
    } else {
      const payload2 = {
        plant: projectName,
        plant_common: checkedItems,
        emails: Mails,
      };
      dispatch(CreatePlantActions(payload2));
      setTimeout(() => {
        refresh();
      }, 200);
    }
    handleSuccessClose();
  };
  useEffect(() => {
    if (Object.keys(editPayload)?.length > 0) {
      setEditMode(true);
      setProjectName(editPayload.plant);
      //console.log(editPayload, "kajfhkafh");
      setMails(editPayload.emails == null ? [] : editPayload.emails);
      if (editPayload.plant_common == null) {
        setCheckedItems([]);
      } else {
        setCheckedItems(editPayload.plant_common);
      }
      // editPayload.plant_common.map((ele)=>(
      //   setUncheckedItems(plantCommonFolder.filter(item => item == ele))
      // ));
    }
  }, [editPayload]);
  const handleClose = () => {
    setEditPayload("");
    setProjectName("");
    setMails([]);
    setShow(false);
  };
  const handleSuccessClose = () => {
    refresh();
    setProjectName("");
    setEditPayload("");
    setMails([]);

    setShow(false);
  };
  return (
    <Modal
      // size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={handleClose}
      className="modelman"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {Object.keys(editPayload).length > 0
            ? "Update Plant"
            : "Create Plant"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="projectName">Plant Name:</label>
          <input
            type="text"
            className="form-control"
            id="projectName"
            onChange={(e) => {
              setProjectName(e.target.value);
            }}
            value={projectName}
          />
        </div>
        <div className="form-group">
          <label htmlFor="cc" className="form-label">
            {" "}
            Cc
          </label>
          <div className="ccMailDiv">
            <TagsInput
              value={Mails}
              id="taginput"
              onChange={(tags) => {
                //console.log(tags);
                setMails(tags);
              }}
              validationRegex={/^[^\s@]+@[^\s@]+\.[^\s@]+$/}
              addOnBlur={true}
              addOnPaste={true}
              className="react-tagsinput-language"
              name="emails"
              inputProps={{
                placeholder: "Email",
              }}
            />
          </div>
        </div>
        <div className="form-group mt-4">
          <div>
            <label>Plant Common</label>
            {plantCommonFolder.map((ele, index) => (
              <div key={index}>
                <input
                  type="checkbox"
                  id={ele}
                  name={ele}
                  onChange={handleCheckboxChange}
                  checked={checkedItems?.includes(ele)}
                />
                <label htmlFor={ele}>{ele}</label>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          style={{ backgroundColor: "#f26639", border: "none" }}
          disabled={projectName.length > 0 ? false : true}
        >
          Submit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PlantPopup;
